import React from "react";
import styles from "./PostSkeleton.module.scss";

const PostSkeleton = () => {
	return (
		<div className={styles.skeletonPostCard}>
			{/* Media Placeholder Area */}
			<div className={styles.skeletonMediaArea}>
				<div className={styles.mediaIconPlaceholder}>
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
						<circle cx="8.5" cy="8.5" r="1.5" />
						<polyline points="21 15 16 10 5 21" />
					</svg>
				</div>
			</div>

			{/* Top Header Placeholder */}
			<div className={styles.skeletonHeader}>
				<div className={styles.skeletonUserBox}>
					<div className={styles.skeletonAvatar} />
					<div className={styles.skeletonTextLines}>
						<div className={styles.skeletonNameLine} />
						<div className={styles.skeletonSubLine} />
					</div>
				</div>

				<div className={styles.skeletonHeaderRight}>
					<div className={styles.skeletonFollowBtn} />
					<div className={styles.skeletonMenuDot} />
				</div>
			</div>

			{/* Bottom Glassmorphic Footer Placeholder */}
			<div className={styles.skeletonFooter}>
				<div className={styles.skeletonCaption}>
					<div className={styles.skeletonCaptionLine1} />
					<div className={styles.skeletonCaptionLine2} />
				</div>

				<div className={styles.skeletonActions}>
					<div className={styles.skeletonActionItem}>
						<div className={styles.skeletonActionCircle} />
						<div className={styles.skeletonActionText} />
					</div>
					<div className={styles.skeletonActionItem}>
						<div className={styles.skeletonActionCircle} />
						<div className={styles.skeletonActionText} />
					</div>
					<div className={styles.skeletonActionItem}>
						<div className={styles.skeletonActionCircle} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PostSkeleton;
